angular.module("app").controller("PagesListNewsAndPromosController", [
    '$scope',
    'preloadedPages',
    '$state',
    'pagesService',
    'errorHandler',
    'logger',
    'settingsService',
    '$timeout',
    'typeToLoad',
    'pageStatuses',
    'userStorage',
    'pageTypes',
    '$cookies',
    'pagination',
    '$uibModal',
    '$rootScope',
    'Utils',
    'tables',
    '$filter',
    '$location',
    'toolsMap',
    'promoDevice',
    function ($scope, preloadedPages, $state, pagesService, errorHandler, logger, settingsService, $timeout, typeToLoad, pageStatuses, userStorage, pageTypes, $cookies, pagination, $modal, $rootScope, Utils, tables, $filter,$location, toolsMap, promoDevice) {

        var settings = settingsService.getSettings(),
            pendingListRequest;
        $scope.userData = userStorage.getUserData();
        $scope.pageTypes = pageTypes;
        $scope.pagination = pagination.init(function () {
            !!pendingListRequest && $timeout.cancel(pendingListRequest);
            pendingListRequest = $timeout(function () {
                $scope.env.pagination = {
                    current_page: $scope.pagination.page,
                    limit: $scope.pagination.limit
                };
                $scope.updateList($scope.selectedLanguage, {
                    current_page: $scope.pagination.page,
                    limit: $scope.pagination.limit
                })
            }, 300);
        }, parseInt(preloadedPages.total_count), 25);
        $scope.state = $state;
        var typePermissions = {
            'news': 'manageNews',
            'promo': 'managePromotions'
        };
        var typeOfPaths = {
            "/pages/all/news": "news",
            "/pages/all/promo": "promo"
        };
        $scope.pageStatuses = angular.copy(pageStatuses);
        $scope.pageStatuses.push("expired");
        $scope.filterOptions = {
            status: $rootScope.env.status || $scope.pageStatuses[0]
        };
        var fieldName = typeOfPaths[$location.path()] === 'news'? 'parentNewsPageId': 'parentPromosPageId';
        var parentPageId =  $rootScope.env[fieldName] || preloadedPages.page.id;
        $rootScope.env[fieldName] = parentPageId;
        Utils.saveEnvToStorage();
        $scope.pages = $filter('filterPagesTableColumns')(preloadedPages.items, 2);
        var initialOrders = getValuesByKey($scope.pages, 'order');
        $scope.languages = settings.skin.languages;
        $scope.selectedLanguage = $rootScope.env.lang || $cookies.get("preferedLanguage") || settings.skin.defaultLang;

        $scope.filterOptions = angular.extend({}, $scope.filterOptions, settingsService.getFilters());
        $scope.editPage = function (page, showMain, hasItems) {
            $state.go("")
        };
        if (typeToLoad === 'promo') {
            $scope.promoDevices = promoDevice;
            $scope.filterOptions.device = $rootScope.env.device || promoDevice[0].value;
        }




        $scope.updateList = function (language, externalOptions) {
            var requestObject = {
                type: typeToLoad,
                limit: $scope.pagination.limit,
                status: $scope.filterOptions.status,
                search: $scope.filterOptions.search,
                page_id: parentPageId
            };
            if (typeToLoad === 'promo') {
                requestObject.device = $scope.filterOptions.device;
                $rootScope.env.device = $scope.filterOptions.device;
            }


            if (!!externalOptions) {
                angular.extend(requestObject, externalOptions)
            }
            $rootScope.env.status = $scope.filterOptions.status;

            Utils.saveEnvToStorage();
            pagesService.getPageItems(requestObject).then(
                function (response) {
                    if (response.status == "ok") {
                        if (!requestObject.current_page) {
                            $scope.pagination.page = 1;
                        }
                        initTools();
                        $scope.pagination.totalItems = parseInt(response.total_count);
                        $scope.pages = $filter('filterPagesTableColumns')(response.items, 2);
                        initialOrders = getValuesByKey($scope.pages, 'order');

                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.toolsAction = function (page, action, title) {
            switch (action){
                case 'delete': {
                    var modalInstance = $modal.open({
                        templateUrl: "views/templates/modals/confirmDeleteAction.html",
                        controller: "ConfirmDeleteActionModalController"
                    });
                    modalInstance.result.then(function () {
                        pagesService.deleteItem(page, parentPageId).then(
                            function (response) {
                                if (response.status == "ok") {
                                    if ($scope.pages.length === 1 && $scope.pagination.page > 1 && ($scope.pagination.page * $scope.pagination.limit >= $scope.pagination.totalItems)) {
                                        $scope.pagination.page = 1;
                                    }
                                    $scope.updateList($scope.selectedLanguage, {
                                        current_page: $scope.pagination.page,
                                        limit: $scope.pagination.limit});
                                    logger.logSuccess("global.successfullyDeleted");
                                } else {
                                    errorHandler(response.message);
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                            }
                        )

                    });
                    break;
                }
                case 'toggleInactive': {
                    var modalInstance = $modal.open({
                        templateUrl: "views/templates/modals/confirmToggle" + title + "Action.html",
                        controller: "ConfirmDeleteActionModalController"
                    });
                    modalInstance.result.then(function () {
                        pagesService.toggleItemInactive(page, parentPageId, title !== 'Publish').then(
                            function (response) {
                                if (response.status == "ok") {
                                    logger.logSuccess("global.updated");
                                    if ($scope.pages.length === 1 && $scope.pagination.page > 1 && ($scope.pagination.page * $scope.pagination.limit >= $scope.pagination.totalItems)) {
                                        $scope.pagination.page = 1;
                                    }
                                    $scope.updateList($scope.selectedLanguage, {
                                        current_page: $scope.pagination.page,
                                        limit: $scope.pagination.limit});
                                } else {
                                    errorHandler(response.message);
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                            }
                        )

                    });
                    break;
                }

            }


        };

        $scope.getDateTime = function (dateString) {
            return new Date(dateString).getTime()
        };

        $scope.publishPage = function (page) {
            pagesService.publishPage(page.id).then(
                function (response) {
                    if (response.status == "ok") {
                        spliceFromList(page);
                        logger.logSuccess("global.successfullyPublished");
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                }
            )
        };

        $scope.checkUserRole = function () {
            return $scope.userData.role !== 'skin_news_manager'
        };

        function spliceFromList(page) {
            var index = $scope.pages.indexOf(page);
            if (index != -1) {
                $scope.pages.splice(index, 1);
            }
        }



        var tableIsInAddRowMode = false;
        /**
         * Add new row in pages table for creating page
         */
        $scope.addPage = function addPage() {
            $state.go("main.pages.createItem", {pageId: parentPageId, type: typeOfPaths[$location.path()] })
        };

        /**
         * Init tools when changing status
         */
        function initTools(){
            if (userStorage.getUserData().permissions.indexOf(typePermissions[typeToLoad]) === -1) {
                return;
            }
            $scope.tools = {
                edit: {
                    action: function (item) {
                        $state.go("main.pages.editItem", {pageId: parentPageId, itemId: item.id, type: typeOfPaths[$location.path()]})
                    },
                    class: function () {
                        return "";
                    },
                    title: function () {
                        return "Edit";
                    }
                },
                inactiveToggle: {
                    action: function (item) {
                        $scope.toolsAction(item, toolsMap[$scope.filterOptions.status].inactiveToggle.action, toolsMap[$scope.filterOptions.status].inactiveToggle.title)
                    },
                    class: function () {
                        return toolsMap[$scope.filterOptions.status].inactiveToggle.class;
                    },
                    title: function () {
                        return toolsMap[$scope.filterOptions.status].inactiveToggle.title;
                    }
                },
                publishToggle: {
                    action: function (item) {
                        $scope.toolsAction(item, toolsMap[$scope.filterOptions.status].publishToggle.action, toolsMap[$scope.filterOptions.status].publishToggle.title  )
                    },
                    class: function () {
                        return toolsMap[$scope.filterOptions.status].publishToggle.class;
                    },
                    title: function () {
                        return toolsMap[$scope.filterOptions.status].publishToggle.title;
                    }
                }
            };
        }
        initTools();
        $scope.ignoreColumns = {
            'id': true,
            'page_id': true,
            'order': true
        };

        $scope.listFilterObject = {
            action: function () {
                $scope.env.pagination = {
                    current_page: $scope.pagination.page,
                    limit: $scope.pagination.limit
                };
                $scope.updateList($scope.selectedLanguage, {
                    current_page: $scope.pagination.page,
                    limit: $scope.pagination.limit
                });
            }
        };

        $scope.allowUpdateContainer = {};
        $scope.allowUpdateContainer.allowUpdate = function (options) {
            if (options && options.autoUpdate) {
                reorder();
            } else if (!!options) {
                $scope.tabOptions.reordered = true;
            }
        };
        function reorder () {
            if (typeof $scope.pages === "object" && $scope.pages.length) {
                reorderByService({
                    ids: getValuesByKey($scope.pages, 'id'),
                    orders: initialOrders,
                    parentId: parentPageId
                }, pagesService);
            }
        }

        function reorderByService (orderData, service) {
            service.changeOrder({
                orderData: orderData
            }).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("global.updated")
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }

        $scope.updateLanguage = function () {
            var requestObject = {
                lang: $scope.selectedLanguage,
                type: typeToLoad,
                limit: $scope.pagination.limit,
                status: $scope.filterOptions.status,
                current_page: 1
            };
            if (typeToLoad === 'promo') {
                requestObject.device = $scope.filterOptions.device;
            }
            $rootScope.env.status = $scope.filterOptions.status;
            $rootScope.env.lang = $scope.selectedLanguage;
            Utils.saveEnvToStorage();
            $scope.pagination.page = 1;
            pagesService.getPages(requestObject).then(
                function (response) {
                    if (response.status == "ok") {
                        initTools();
                        $scope.pagination.totalItems = parseInt(response.total_count);
                        $scope.pages = $filter('filterPagesTableColumns')(response.items, 2);
                        initialOrders = getValuesByKey($scope.pages, 'order');
                        parentPageId = response.page.id;
                        $rootScope.env[fieldName] = parentPageId;
                        Utils.saveEnvToStorage();
                        if ($scope.filterOptions.search){
                            $scope.updateList($scope.selectedLanguage, {
                                current_page: $scope.pagination.page,
                                limit: $scope.pagination.limit
                            });
                        }

                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )


        };


    }
]);
